import type { CSSProperties } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export interface Layout3ThemeColors {
  header: string;
  menu: string;
  primary: string;
  secondary: string;
  button: string;
  title: string;
  text: string;
}

/**
 * Mapeamento de themeColors (igual templates 1 e 2):
 * - header  → fundo da barra principal do header
 * - menu    → fundo da topbar + cor dos links do menu
 * - primary → fundo do footer + destaques/CTAs grandes
 * - button  → botões de ação (buscar, WhatsApp, favoritos badge)
 * - title   → títulos de seção e nomes de veículos
 * - text    → textos de corpo e descrições
 * - secondary → badges e elementos secundários
 */
export function getLayout3ThemeStyle(colors: Layout3ThemeColors): CSSProperties {
  return {
    '--wl3-accent': colors.button,
    '--l3-accent': colors.button,
    '--wl3-primary': colors.primary,
    '--wl3-secondary': colors.secondary,
    '--wl3-button': colors.button,
    '--wl3-title': colors.title,
    '--wl3-text': colors.text,
    '--wl3-muted': colors.text,
    '--wl3-header': colors.header,
    '--wl3-menu': colors.menu,
    '--wl3-accent-bg': `${colors.button}12`,
  } as CSSProperties;
}

export function useLayout3Theme() {
  const { colors } = useTheme();

  return {
    colors,
    themeStyle: getLayout3ThemeStyle(colors),
    headerColor: colors.header,
    menuColor: colors.menu,
    primaryColor: colors.primary,
    secondaryColor: colors.secondary,
    buttonColor: colors.button,
    titleColor: colors.title,
    textColor: colors.text,
  };
}
